module.exports = __webpack_public_path__ + "static/image/history/pc/202512_2.ver2_0_2.jpg?fa23c697";